// FUN FACT: the reason this folder can't be name /icon is because
// https://stackoverflow.com/questions/21109672/git-ignoring-icon-files-because-of-icon-rule
import React from 'react';
import classNames from 'classnames';

import withTooltip from '../../../components/ui/Tooltip';

import { ICON_SIZE, VALID_ICON_SIZES } from './constants';

import './styles.scss';

const SVGIconFn = ({
  className,
  icon,
  style,
  square,
  size = ICON_SIZE.REGULAR,
  ...restProps
}) => {
  const svgClass = icon || 'span';
  const iconSizeClass = VALID_ICON_SIZES.has(size)
    ? `icon-size-${size}`
    : 'icon-size-24';
  const svgClassName = classNames(
    'icon icon-svg icon-color',
    iconSizeClass,
    className,
    { square },
  );

  return React.createElement(svgClass, {
    style,
    className: svgClassName,
    role: 'presentation',
    ...restProps,
  });
};

SVGIconFn.displayName = 'SVGIconFn';

export default withTooltip(SVGIconFn);
